<template>
    <div class="contact-page-container container hidden">
        <section class="contact-us">
            <h1>Vragen?</h1>
            <p>Neem contact met ons op</p>
            <div class="row-contact">
                <div class="contact-col">
                    <div>
                        <i class="fa-solid fa-house"></i>
                        <div class="branches-contact">
                            <span>
                                <h5>Schijndelseweg 13A</h5>
                                <p>5271 BK Sint-Michielsgestel</p>
                            </span>
                        </div>
                    </div>
                    <div>
                        <i class="fa-solid fa-clock"></i>
                        <span>
                            <h5>Openingstijden</h5>
                            <p>Ma t/m do van 08:15 - 17:00<br>Vr van 08:00 - 12:30</p>               

                        </span>
                    </div>
                    <div>
                        <i class="fa-solid fa-phone"></i>
                        <span>
                            <h5><a href="tel:+31735515644" class="contact-link">073-5515644</a></h5>
                            <p><strong>Telefonisch bereikbaar:</strong><br>
                            Ma - Do: 08:15 - 17:00<br>
                            Vrijdag: 08:00 - 12:30<br>
                            <em>Tijdens pauzes zijn wij niet bereikbaar.</em></p>
                        </span>
                    </div>
                    <div>
                        <i class="fa-solid fa-envelope"></i>
                        <span>
                            <h5><a href="mailto:info@tandzorggestel.nl" class="contact-link">info@tandzorggestel.nl</a></h5>
                            <p>U kunt ons altijd mailen</p>
                        </span>
                    </div>
                </div>
                <div class="contact-col google-maps-location">
                    <div class="no-mobile-map"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2476.2104561607784!2d5.350769277267544!3d51.6376707718433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6e9b0cfd3fb27%3A0xcd7cce602fa2c96f!2sTandzorg%20Gestel!5e0!3m2!1snl!2snl!4v1742124181681!5m2!1snl!2snl" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
                    <div class="mobile-map"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2476.2104561607784!2d5.350769277267544!3d51.6376707718433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6e9b0cfd3fb27%3A0xcd7cce602fa2c96f!2sTandzorg%20Gestel!5e0!3m2!1snl!2snl!4v1742124181681!5m2!1snl!2snl" width="auto" height="200" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
                </div>
                <!-- <div class="contact-col contact-form-container" v-if="!showThankYouMessage">
                    <form ref="contactForm" @submit.prevent="sendEmail" method="POST" id="contact-form" >
                        <input type="text" name="naam" v-model="nameInput" :placeholder="namePlaceholder" :class="!nameValid ? 'error' : ''" @blur="validateName()">
                        <input type="email" name="email" v-model="emailInput" :placeholder="emailPlaceholder" :class="!emailValid ? 'error' : ''" @blur="validateEmail()">
                        <input type="text" name="onderwerp" :placeholder="subjectPlaceholder">
                        <textarea rows="8" name="bericht" v-model="messageInput" :placeholder="messagePlaceholder" :class="!messageValid ? 'error' : ''" @blur="validateMessage()"></textarea>
                        <button type="submit" class="hero-btn red-btn">Verzenden</button>
                    </form>
                </div>
                <div v-if="showThankYouMessage" class="thank-you-message-contact">
                        <h5 class="title">Bedankt voor je bericht</h5>
                        <div class="message">
                            <div class="greeting">Beste {{ nameInput }},</div>
                            <div class="content"> Bedankt voor je bericht. We zullen z.s.m contact met je opnemen.</div>
                            <div class="end-greeting">Met vriendelijke groet,</div>
                            <div>Team Tandzorg Gestel</div>
                        </div>
                </div> -->
            </div>
        </section>
    </div>
</template>

<script>
import emailjs from '@emailjs/browser';



export default {
name: "Contact",
data() {
    return {
        nameInput: '',
        namePlaceholder: 'Naam',
        emailInput: '',
        emailPlaceholder: 'Email',
        subjectInput: '',
        subjectPlaceholder: 'Onderwerp',
        messageInput: '',
        messagePlaceholder: 'Bericht',
        nameValid: true,
        emailValid: true,
        messageValid: true,
        showThankYouMessage: false
    }
  },
  methods: {
    validateName(){
            if(this.nameInput == '') {
                this.nameValid= false;
                this.namePlaceholder = 'Naam is verplicht'
            }
            else {
                this.nameValid = true;
            } 
        },
    validateEmail(){
        var validRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        if(this.emailInput == '') {
            this.emailValid= false;
            this.emailPlaceholder = 'Email is verplicht'
        }          
         else if(!this.emailInput.match(validRegex)) {
            this.emailValid= false;
            this.emailPlaceholder = this.emailInput + ' is geen geldig email';
            this.emailInput = "";
            }
        else {
            this.emailValid = true;
        } 
    },
    validateMessage(){
            if(this.messageInput == '') {
                this.messageValid= false;
                this.messagePlaceholder = 'Bericht is verplicht'
            }
            else {
                this.messageValid = true;
            } 
        },
    validateForm(){

            this.validateName();
            this.validateEmail();
            this.validateMessage();

            if(this.nameValid && this.emailValid && this.messageValid){
                this.$refs.contactForm.submit();
            } 
        },
    sendEmail() {
            this.validateName();
            this.validateEmail();
            this.validateMessage();

            if(this.nameValid && this.emailValid && this.messageValid) {
                emailjs.sendForm('contact_service', 'contact_form', this.$refs.contactForm, 'pz4YFDqG2mmE4DiOl')
                .then((result) => {
                    console.log('SUCCESS!', result.text);
                    this.showThankYouMessage = true
                }, (error) => {
                    console.log('FAILED...', error.text);
                    this.showThankYouMessage = false
                });
            } 
    }
  },
mounted(){

      const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
                if(entry.isIntersecting){
                entry.target.classList.add('show')
              } 
          })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))

      document.title = "Contact | Tandzorg Gestel | Afspraak Maken Sint-Michielsgestel"
      document.querySelector('meta[name="description"]').setAttribute("content", "Neem contact op met Tandzorg Gestel voor afspraken, vragen of spoedgevallen. Bereikbaar in Sint-Michielsgestel. Nieuwe patiënten welkom!");
      this.$store.commit('updateActivePage', 'Contact')
    }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateX(0);
}

.contact-page-container {
    /* background-color: pink; */
    margin-top: 65px;
}

.row-contact {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    /* background-color: pink; */
}

.contact-us {
    /* width: 80%; */
    margin: auto;
    text-align: center;
    padding: 80px 0 50px;        /* t lr b */
}
.contact-us h1 {
    font-size: 36px;
}
.contact-us p {
    font-size: 14px;
}
.contact-col {
    flex-basis: 48%;
    margin-bottom: 30px;
    text-align: left;
    margin-top: 20px;
}
.contact-col div {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
}
.contact-col div .fa-solid, .contact-col div .fa-regular{
    font-size: 28px;
    color: #00B8B8;
    margin: 10px;
    margin-right: 30px;
}
.contact-col p {
    padding: 0;
}
.contact-col div h5 {
    font-size: 20px;
    margin-bottom: 5px;
    color: #555;
    font-weight: 400;
}
.contact-col div p {
    font-size: 14px;
}
.contact-col input, .contact-col textarea {
    width: 100%;
    padding: 15px;
    margin-bottom: 17px;
    outline: none;
    border: 1px solid #CCC;
    box-sizing: border-box;
    resize: none;
    font-size: 14px;
}

.contact-col .branches-contact {
    /* background-color: red; */
    margin-bottom: 0px;
    display: flex;
    column-gap: 40px;
    /* flex-direction: column; */
}

.hero-btn {
    display: inline-block;
    text-decoration: none !important;
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    padding: 12px 34px;
    font-size: 16px;
    background: transparent;
    position: relative;
    cursor: pointer;
}
.hero-btn:hover {
    border: 1px solid var(--blue);
    background: var(--blue);
    transition: 1s;
}
.red-btn {
    border: 1px solid var(--blue);
    background: transparent;
    color: var(--blue);
    margin-top: 20px;
}
.red-btn:hover {
    color: #FFF;
}

.error::-webkit-input-placeholder {
    color: red;
}

.thank-you-message-contact {
    flex-basis: 48%;
    text-align: left;
    padding-top: 14px;
    min-height: 406px;
}

.thank-you-message-contact .title {
    font-size: 24px;
    padding-bottom: 15px;
    color: #555;
    font-weight: 400;
}
.thank-you-message-contact .message {
    color: #606060;
    font-size: 16px
}
.thank-you-message-contact .message .greeting{
    padding-bottom:15px;
}
.thank-you-message-contact .message .content{
    padding-bottom:15px;
}
.thank-you-message-contact .message .end-greeting{
    padding-bottom:5px;
}

.contact-form-container {
    margin-top: 10px;
}
.mobile-map {
    display: none !important;
}

@media(max-width: 991px) {
    .contact-us {
        padding: 40px 0 0px;        /* t lr b */
    }
    .contact-col:first-child {
        margin-bottom: 25px;
    }
    .contact-col {
        margin: -10px 0px 50px;
    }
    .contact-col .branches-contact {
        flex-direction: column;
        row-gap: 15px;
        align-items: flex-start;
    }
    .contact-col input, .contact-col textarea {
        font-size: 12px;
    }

    .row-contact {
        flex-direction: column;
    }
    .thank-you-message-contact {
        padding-top: 0px;
        padding-bottom: 50px;
        min-height: 0px;
    }
    .thank-you-message-contact .title {
        font-size: 20px;
    }
    .thank-you-message-contact .message {
        color: #606060;
        font-size: 13px
    }
    .contact-col div .fa-solid, .contact-col div .fa-regular{
        font-size: 25px;
    }
    .contact-col div h5 {
        font-size: 17px;
    }
    .contact-us h1 {
        font-size: 20px;
    }
    .mobile-map {
        display: block !important;
    }
    .no-mobile-map {
        display: none !important;
    }
}
</style>